export enum VISAVALUE {
  EMPTY = "",
  I589 = "Asylum",
  PERM = "PERM",
  EB1A = "EB-1A",
  EB1B = "EB-1B",
  EB1C = "EB-1C",
  EB2NIW = "EB-2 NIW",
  EB2NIW_V2 = "EB-2 NIW v2",
  EB5 = "EB-5",
  E1 = "E-1",
  E2 = "E-2",
  E3 = "E-3",
  H1B = "H-1B",
  L1A = "L-1A",
  L1B = "L-1B",
  O1B = "O-1B",
  O1A = "O-1A",
  TN = "TN",
  I601 = "I-601",
  I601A = "I-601A",
  I130 = "I-130",
  SCHEDULE_A_G2 = "Schedule A, Group II",
  VAWA = "VAWA",
  U = "U",
  AOS = "AOS",
  N400 = "N-400",
  T = "T",
  I212 = "I-212",
  EOIR_42B = "42B",
  EOIR_42A = "42A",
  STEMOPT = "STEM OPT",
  I140_APPROVED_LC = "I-140 - Approved Labor Certification",
  P1A = "P-1A",
  P1B = "P-1B",
  R1 = "R-1",
  K1 = "K-1",
  I751 = "I-751",
  BOND = "Bond",
  VAWA_CANCELLATION = "VAWA Cancellation",
  I246 = "I-246 - Stay of Removal",
  HABEAS = "Habeas",
  MANDAMUS = "Mandamus",
  MOTION_TO_REOPEN_RECONSIDER = "Motions to Reopen/Reconsider",
  H2B = "H-2B",
  I612 = "I-612 - J-1 Waiver",
  P3 = "P-3",
  H2A = "H-2A",
  O2 = "O-2",
  I829 = "I-829",
  H3 = "H-3",
  I602 = "I-602",
  SIJS = "SIJS",
  B1 = "B-1",
  TPS = "TPS",
  CUSTOM_TEMPLATE = "Custom Workflow",
  N600 = "N-600",
  PAROLE_IN_PLACE = "Parole in Place",
  MILITARY_PAROLE_IN_PLACE = "Military Parole in Place"
}

export const MapVisaToFeatureType: Record<NonEmptyVisa, string> = {
  [VISAVALUE.I589]: "",
  [VISAVALUE.PERM]: "",
  [VISAVALUE.EB1A]: "",
  [VISAVALUE.EB1B]: "",
  [VISAVALUE.EB1C]: "",
  [VISAVALUE.EB5]: "",
  [VISAVALUE.E1]: "",
  [VISAVALUE.E2]: "",
  [VISAVALUE.EB2NIW]: "",
  [VISAVALUE.EB2NIW_V2]: "",
  [VISAVALUE.E3]: "",
  [VISAVALUE.H1B]: "",
  [VISAVALUE.L1A]: "",
  [VISAVALUE.L1B]: "",
  [VISAVALUE.O1A]: "",
  [VISAVALUE.O1B]: "",
  [VISAVALUE.TN]: "",
  [VISAVALUE.I601]: "",
  [VISAVALUE.I601A]: "",
  [VISAVALUE.I130]: "",
  [VISAVALUE.SCHEDULE_A_G2]: "",
  [VISAVALUE.VAWA]: "",
  [VISAVALUE.U]: "",
  [VISAVALUE.AOS]: "",
  [VISAVALUE.N400]: "",
  [VISAVALUE.T]: "",
  [VISAVALUE.I212]: "",
  [VISAVALUE.EOIR_42B]: "",
  [VISAVALUE.EOIR_42A]: "",
  [VISAVALUE.STEMOPT]: "",
  [VISAVALUE.I140_APPROVED_LC]: "",
  [VISAVALUE.P1A]: "",
  [VISAVALUE.P1B]: "",
  [VISAVALUE.R1]: "",
  [VISAVALUE.K1]: "",
  [VISAVALUE.I751]: "",
  [VISAVALUE.BOND]: "",
  [VISAVALUE.VAWA_CANCELLATION]: "",
  [VISAVALUE.I246]: "",
  [VISAVALUE.HABEAS]: "",
  [VISAVALUE.MANDAMUS]: "",
  [VISAVALUE.MOTION_TO_REOPEN_RECONSIDER]: "",
  [VISAVALUE.H2B]: "",
  [VISAVALUE.I612]: "",
  [VISAVALUE.P3]: "",
  [VISAVALUE.H2A]: "",
  [VISAVALUE.O2]: "",
  [VISAVALUE.I829]: "",
  [VISAVALUE.H3]: "",
  [VISAVALUE.I602]: "",
  [VISAVALUE.SIJS]: "",
  [VISAVALUE.B1]: "",
  [VISAVALUE.TPS]: "",
  [VISAVALUE.CUSTOM_TEMPLATE]: "",
  [VISAVALUE.N600]: "",
  [VISAVALUE.PAROLE_IN_PLACE]: "",
  [VISAVALUE.MILITARY_PAROLE_IN_PLACE]: ""
};

export type NonEmptyVisa = Exclude<VISAVALUE, VISAVALUE.EMPTY>;

/**
 * Employment-based / "Business Immigration" workflows. This is the full superset
 * (not env-flag gated) so membership checks are stable regardless of which
 * workflows are enabled in a given environment. Keep in sync with the
 * "employment-based" category in VisaTypeSelector.tsx.
 */
export const EMPLOYMENT_BASED_VISAS: ReadonlySet<VISAVALUE> = new Set([
  VISAVALUE.E1,
  VISAVALUE.E2,
  VISAVALUE.E3,
  VISAVALUE.EB1A,
  VISAVALUE.EB1B,
  VISAVALUE.EB1C,
  VISAVALUE.EB2NIW,
  VISAVALUE.EB2NIW_V2,
  VISAVALUE.EB5,
  VISAVALUE.I829,
  VISAVALUE.H1B,
  VISAVALUE.H2A,
  VISAVALUE.H2B,
  VISAVALUE.H3,
  VISAVALUE.L1A,
  VISAVALUE.L1B,
  VISAVALUE.O1A,
  VISAVALUE.O1B,
  VISAVALUE.O2,
  VISAVALUE.P1A,
  VISAVALUE.P1B,
  VISAVALUE.P3,
  VISAVALUE.R1,
  VISAVALUE.TN,
  VISAVALUE.STEMOPT,
  VISAVALUE.PERM,
  VISAVALUE.SCHEDULE_A_G2,
  VISAVALUE.I140_APPROVED_LC,
  VISAVALUE.B1
]);

export const isEmploymentBasedVisa = (visa?: VISAVALUE | null): boolean => {
  if (!visa) return false;
  return EMPLOYMENT_BASED_VISAS.has(visa);
};

export const isPetitionerVisa = (visa?: VISAVALUE | null): boolean => {
  if (!visa) return false;
  return (
    visa === VISAVALUE.I601A ||
    visa === VISAVALUE.I601 ||
    visa === VISAVALUE.I130 ||
    visa === VISAVALUE.H2A ||
    visa === VISAVALUE.H2B ||
    visa === VISAVALUE.H3 ||
    visa === VISAVALUE.B1 ||
    visa === VISAVALUE.O2 ||
    visa === VISAVALUE.P3
  );
};

export type RECOMMENDED_UPLOADS_DOCS =
  | "Resume"
  | "Passport"
  | "Government ID"
  | "RFE Notice"
  | "NOID/NOIR Notice"
  | "Birth Certificate"
  | "Permanent Resident Card";

export const RECOMMENDED_UPLOADS: Record<string, RECOMMENDED_UPLOADS_DOCS[]> = {
  [VISAVALUE.STEMOPT]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.PERM]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.EB1A]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.EB1B]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.EB1C]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.EB2NIW]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.EB2NIW_V2]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.EB5]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.E1]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.E2]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.E3]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.H1B]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.L1A]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.L1B]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.O1A]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.O1B]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.TN]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.SCHEDULE_A_G2]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.I140_APPROVED_LC]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.P1A]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.P1B]: ["Passport", "Government ID"],
  [VISAVALUE.R1]: ["Passport", "Government ID"],
  [VISAVALUE.I589]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.I601]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.I601A]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.I130]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.K1]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.VAWA]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.U]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.AOS]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.N400]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.I751]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.T]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.I212]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.EOIR_42B]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.EOIR_42A]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.BOND]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.VAWA_CANCELLATION]: [
    "Passport",
    "Government ID",
    "Birth Certificate"
  ],
  [VISAVALUE.I246]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.HABEAS]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.MANDAMUS]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.MOTION_TO_REOPEN_RECONSIDER]: [
    "Passport",
    "Government ID",
    "Birth Certificate"
  ],
  [VISAVALUE.H2B]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.I612]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.P3]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.H2A]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.O2]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.I829]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.H3]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.I602]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.SIJS]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.B1]: ["Resume", "Passport", "Government ID"],
  [VISAVALUE.TPS]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.CUSTOM_TEMPLATE]: [
    "Passport",
    "Government ID",
    "Birth Certificate"
  ],
  [VISAVALUE.N600]: ["Passport", "Government ID", "Birth Certificate"],
  [VISAVALUE.PAROLE_IN_PLACE]: [
    "Passport",
    "Government ID",
    "Birth Certificate"
  ],
  [VISAVALUE.MILITARY_PAROLE_IN_PLACE]: [
    "Passport",
    "Government ID",
    "Birth Certificate"
  ],
  RFE: ["RFE Notice"],
  "NOID/NOIR": ["NOID/NOIR Notice"],
  default: ["Passport", "Government ID", "Resume"]
};
